
import { useEffect, useState } from 'react'
import { onChainProvider } from '../types/OnChainProvider';
import { universeContract } from '../utils/contracts';
import { useWeb3Context } from './useWeb3Context';

function useFetchTokens(
    txLog: any = [],
    quantity: number,
    setIsViewingCollection: React.Dispatch<React.SetStateAction<boolean>>,
    setMintLoadingState: React.Dispatch<React.SetStateAction<{
        isLoading: boolean,
        title: string,
        description: string
    }>>
) {
    const { address, provider }: onChainProvider = useWeb3Context();
    const [mintedNFTs, setMintedNFTs]: any = useState([]);
    const [mintedNFTsIsLoading, setMintedNFTsIsLoading] = useState(true);

    useEffect(() => {
        const getMintedTokensData = async () => {
            if (address && txLog && txLog.events && txLog.events.length > 0) {
                let arr: Array<any> = []
                const events = txLog.events;
                for (let i = 0; i < events.length; i++) {
                    if (events[i].topics[3]) {
                        const tokenID = parseInt(events[i].topics[3]);
                        const baseURL = await universeContract(provider).tokenURI(tokenID);
                        console.log('baseURL', baseURL)
                        const res = await fetch(baseURL, { method: 'GET' })
                        const json = await res.json()
                        if (json) {
                            json.tokenID = tokenID
                            arr.push(json);
                        }
                        if (arr.length >= quantity) {
                            setMintedNFTs(arr);
                            setMintedNFTsIsLoading(false);

                            setIsViewingCollection(true);
                            setMintLoadingState({
                                isLoading: false,
                                title: '',
                                description: ''
                            });
                        }
                    }
                }
            }
        }

        getMintedTokensData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [txLog])

    return {
        mintedNFTs,
        mintedNFTsIsLoading,
        setMintedNFTs,
        setMintedNFTsIsLoading
    }
}

export default useFetchTokens;